<template>
    <div class="col-12 col-sm-6 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-danger elevation-1"><i class="fas fa-calendar-day"></i></span>

              <div class="info-box-content">
                <span class="info-box-text text-bold">Today Tickets</span>
                <span class="info-box-number text-bold">{{ TicketToday }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
</template>

<script>
    export default {
        name: 'ticket-counter-today',
        data(){
            return {
                TicketToday : 0,
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>